import axios from 'axios';

import config from '../config';

export const getSiteStatus = async () => {
  // HACK This should be a special purpose endpoint; this one is used because a special purpose
  // site status endpoint doesn't exist yet
  const url = `${config.API_ROOT}/api/v1/operatinghours.json/hours/department/1/open`;
  try {
    await axios.get(url);
    // If a request to the API returns successfully the site is not in maintenance mode
    return { maintenance: false };
  } catch (err) {
    // If a request to the API returns a response that can't be read then consider the app in
    // maintenance mode. This is because NGINX doesn't pass CORS headers when maintenance mode is on
    if (err.response) {
      return { maintenance: false };
    }
    return { maintenance: true };
  }
};

export const isEmailAvailable = async email => {
  const url = `${config.API_ROOT}/api/v1/signup.json/post_account_available`;
  const requestParams = {
    email,
  };

  const response = await axios.post(url, requestParams);

  return !!response.data && !!response.data.success;
};

export const createClient = ({ password, ...payload }) => {
  const url = `${config.API_ROOT}/api/v1/signup.json/create_and_login`;

  // Legacy API requirement that hurts my soul
  const accountParams = {
    ...payload,
    password1: password,
    password2: password,
  };

  return axios.post(url, accountParams, { withCredentials: true });
};

export const createStripeCustomer = clientId => {
  return axios.post(
    `${config.API_ROOT}/api/v1/billing.json/client/${clientId}`,
    {},
    { withCredentials: true },
  );
};

export const getUserLoginStatus = async () => {
  const url = `${config.API_ROOT}/api/v1/security.json/user`;
  const result = await axios.get(url, { withCredentials: true });

  return result.data.roles[0] !== 'ANONYMOUS';
};
